// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2YjoT","icon--small":"Icon_icon--small__KXXKI","icon--big":"Icon_icon--big__2zgWm"};